// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Text } from '@mantine/core';
import { FC } from 'react';
import { BookitupNotification } from '../../../../Types/LogT';

const MailOpened: FC<{ notification: BookitupNotification }> = ({ notification }) => {
  const { personDescription, mailSubject } = notification;
  return (
    <Text>
      <Text span weight="bolder">
        {personDescription}
      </Text>
      {'  '}
      hat E-Mail{'  '}
      <Text span weight="bolder">
        {mailSubject}
      </Text>
      {'  '}
      geöffnet.
    </Text>
  );
};

export default MailOpened;
